import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table, Tooltip } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import svg15 from "../../../assets/svg/svg15.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import {
  fetchCounties,
  fetchCrops,
  fetchData,
  fetchFundingMode,
  fetchIrrigationType,
  fetchMemberTypes,
  fetchWaterSources,
  fetchWtrAbstraction,
  fetchWtrApplMode,
  fetchWtrConvMeans,
} from "../../../features/fetch/fetchSlice";
import moment from "moment";
import { setActiveObj } from "../../../features/obj/objSlice";
import { schemeTypeData } from "../../../data";

function SchemeTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const formRef = useRef(null);

  const url = "main_scheme/fetch_mainschemes";
  const urlAgency = "api/v2/stateAgency/get";
  const urlFundingSrc = "sch/get_funding_source";
  const urlSchCard = "sch/get_dashboard";
  const urlPathway = "api/v2/irrigationPathway/get";
  const { loading, data, count, activeObjPathCard } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    dataPathway: state.fetch.data[urlPathway] || [],
    activeObjPathCard: state.obj.activeObj["pathwayCard"],
  }));

  const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [selectId, setSelectId] = useState("PUBLIC");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        schName: e.target.value == "" ? null : e.target.value,
        schSchemeType: selectId,
        schPathwayId: activeObjPathCard?.irrigationPathwayId,
        limit: null,
        start: 0,
      })
    );
  };
  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const handleEdit = async () => {
    await dispatch(
      setActiveObj({
        key:
          selectId === "PUBLIC"
            ? "schemes"
            : selectId === "PRIVATE"
            ? "privateSchemes"
            : selectId === "COMMUNITY"
            ? "communitySchemes"
            : selectId === "ASAL"
            ? "asalSchemes"
            : null,
        data: prodd,
      })
    );
    await navigate(
      selectId === "PUBLIC"
        ? "/scheme/public-scheme-view"
        : selectId === "PRIVATE"
        ? "/scheme/private-scheme-view"
        : selectId === "COMMUNITY"
        ? "/scheme/community-scheme-view"
        : selectId === "ASAL"
        ? "/scheme/asal-scheme-view"
        : null
    );
  };

  const handleView = async (item) => {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: item?.schId,
        limit: null,
        start: 0,
      })
    );
    await navigate(
      selectId === "PUBLIC"
        ? "/scheme/public-scheme-view"
        : selectId === "PRIVATE"
        ? "/scheme/private-scheme-view"
        : selectId === "COMMUNITY"
        ? "/scheme/community-scheme-view"
        : selectId === "ASAL"
        ? "/scheme/asal-scheme-view"
        : null
    );
    await dispatch(
      setActiveObj({
        key:
          selectId === "PUBLIC"
            ? "schemes"
            : selectId === "PRIVATE"
            ? "privateSchemes"
            : selectId === "COMMUNITY"
            ? "communitySchemes"
            : selectId === "ASAL"
            ? "asalSchemes"
            : null,
        data: item,
      })
    );
  };
  const handleViewName = async (item) => {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: item?.schId,
        limit: null,
        start: 0,
      })
    );
    await navigate(
      selectId === "PUBLIC"
        ? "/scheme/public-scheme-view"
        : selectId === "PRIVATE"
        ? "/scheme/private-scheme-view"
        : selectId === "COMMUNITY"
        ? "/scheme/community-scheme-view"
        : selectId === "ASAL"
        ? "/scheme/asal-scheme-view"
        : null
    );
    await dispatch(
      setActiveObj({
        key:
          selectId === "PUBLIC"
            ? "schemes"
            : selectId === "PRIVATE"
            ? "privateSchemes"
            : selectId === "COMMUNITY"
            ? "communitySchemes"
            : selectId === "ASAL"
            ? "asalSchemes"
            : null,
        data: item,
      })
    );
  };

  const settingItems = [
    {
      key: "0",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem]  ">
            <img src={svg15} alt="svg15" className="w-4 h-4" /> View
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },

    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2">
            <img src={svg12} alt="svg12" className="w-4 h-4" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <Link className="flex actions-text gap-x-[.75rem] my-2">
    //       <img src={svg13} alt="svg13" className="w-4 h-4" /> Delete
    //     </Link>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.schName}
          </div>
        );
      },
      sorter: (a, b) => a.schName.localeCompare(b.schName),
    },
    {
      title: "County",
      dataIndex: "schSubCountyName",
      sorter: (a, b) => a.schSubCountyName.localeCompare(b.schSubCountyName),
    },
    {
      title: "Subcounty",
      dataIndex: "schSubCountyName",
      sorter: (a, b) => a.schSubCountyName.localeCompare(b.schSubCountyName),
    },
    {
      title: "Scheme Type",
      dataIndex: "schSchemeType",
      sorter: (a, b) => a.schSchemeType.localeCompare(b.schSchemeType),
    },

    {
      title: "Farm Size",
      dataIndex: "schLandSize",
      sorter: (a, b) => a.schLandSize.localeCompare(b.schLandSize),
    },
    {
      title: "Irrigation Type",
      dataIndex: "schIrrigationType",
      sorter: (a, b) => a.schIrrigationType.localeCompare(b.schIrrigationType),
    },

    {
      title: "Cost",
      dataIndex: "schFarmersNumber",
      sorter: (a, b) => a.schFarmersNumber.localeCompare(b.schFarmersNumber),
    },

    {
      title: "Start Date",
      dataIndex: "schConstructionStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.schConstructionStartDate).valueOf() -
        moment(b.schConstructionStartDate).valueOf(),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <button onClick={() => handleView(item)}>
            <img src={svg15} alt="svg15" />
          </button>
          {/* <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown> */}
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchSchemeData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        schPathwayId: activeObjPathCard?.irrigationPathwayId,
        schSchemeType: selectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchAgencyData() {
    await dispatch(
      fetchData({
        url: urlAgency,
        limit: null,
        start: 0,
      })
    );
  }

  async function fetchFundingSrcData() {
    await dispatch(
      fetchData({
        url: urlFundingSrc,
        limit: null,
        start: 0,
      })
    );
  }

  // useEffect(() => {
  //   fetchSchemeData();
  // }, []);

  useEffect(() => {
    if (refetchKey == 1) {
      fetchSchemeData();
    }
  }, [refetchKey, selectId]);


  useEffect(() => { 
      fetchSchemeData(); 
  }, [selectId]);

  useEffect(() => {
    // dispatch(fetchCrops());
    // dispatch(fetchWaterSources());
    // dispatch(fetchIrrigationType());
    // dispatch(fetchCounties());
    // dispatch(fetchMemberTypes());

    // dispatch(fetchFundingMode());
    // dispatch(fetchWtrConvMeans());
    // dispatch(fetchWtrApplMode());
    // dispatch(fetchWtrAbstraction());
    // fetchAgencyData();
    // fetchFundingSrcData();
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="min-h-[88vh] flex flex-col">
      <div className="flex flex-col w-full  flex-1 ">
        <div className="flex items-center justify-between">
          <div className="lg:w-[29.1875rem] w-auto">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            className="w-full lg:w-[15%]"
            form={form}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                schemeTypeData?.length > 0 &&
                schemeTypeData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              value={selectId}
              onChange={(value) => setSelectId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form>
        </div>

        <Table
          rowSelection={false}
          className="mt-[1.31rem] w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.schId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchSchemeData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>
    </div>
  );
}

export default SchemeTable;
